import * as _ from "lodash-es";
import React, { Component } from "react";
import ControlTypeEnum from "../../../models/ControlTypeEnum";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IViewOptions from "../../../models/IViewOptions";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import OwPrintButton from "../OwPrintButton/OwPrintButton";
import { OwViewOptionsPanel } from "../OwViewOptionsPanel/OwViewOptionsPanel";
import OrderPackingListView from "./OrderPackingListView/OrderPackingListView";
import styled from "styled-components";
import EndpointsEnum from "../../../models/EndpointsEnum";
import { Socket } from "socket.io-client";
import OwButton from "../OwButton/OwButton";
import BulkOrderSubmitModal from "../../orders/BulkOrderSubmitModal/BulkOrderSubmitModal";
import Modal from "react-modal";
import ISupplierSettings from "../../../models/ISupplierSettings";
import IOnUpdateSupplierSettingsDTO from "../../../models/DTO/IOnUpdateSupplierSettingsDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IUpdateSupplierSettingsDTO from "../../../models/DTO/IUpdateSupplierSettingsDTO";
import IVermontAvery8136DTO from "../../../models/DTO/IVermontAvery8136DTO";
import IOnVermontAvery8136DTO from "../../../models/DTO/IOnVermontAvery8136DTO";
import UIService from "../../../services/UIService";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import { IOption } from "../../../models/IOption";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: Component) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    /**
     * @deprecated
     */
    toggleMenu: () => void;
    history: any;
    location: any;
};

type State = {
    orderGuids: string[];
    onGetOrderDTO?: any;
    navItems?: IBreadcrumbs[];
    showPhone: boolean;
    showEmail: boolean;
    showOrderQty: boolean;
    showShipQty: boolean;
    showDropshipment: boolean;
    showOrderDescription: boolean;
    showSku: boolean;
    showUpc: boolean;
    showItemPhoto: boolean;
    hideSkuCol: boolean;
    showBillToPhone: boolean;
    showBillTo: boolean;
    showShipToPhone: boolean;
    showOrderUser: boolean;
    showItemLocation: boolean;
    showUom: boolean;
    hideBusinessName: boolean;
    inlineLogoName: boolean;
    modalIsOpen: boolean;
    modalComponent: any;
    orders: IOrder[];
    selectedTemplate: "STANDARD" | "MINIMAL";
};

class OrderPackingList extends Component<Props, State> {
    supplierSettings: ISupplierSettings =
        typeof this.props.supplierModel.settings === "string"
            ? JSON.parse(this.props.supplierModel.settings)
            : this.props.supplierModel.settings;

    getSupplierSetting = (viewOption: string, defaultValue: boolean): boolean => {
        // @ts-expect-error
        if (this.supplierSettings.simple_packing_list && !_.isNil(this.supplierSettings.simple_packing_list[viewOption])) {
            // @ts-expect-error
            return this.supplierSettings.simple_packing_list[viewOption];
        } else {
            return defaultValue;
        }
    };

    readonly state: State = {
        orderGuids: [],
        orders: [],
        navItems: [],
        showPhone: this.getSupplierSetting("show_phone", false),
        showEmail: this.getSupplierSetting("show_email", true),
        showOrderQty: this.getSupplierSetting("show_order_qty", true),
        showShipQty: this.getSupplierSetting("show_ship_qty", true),
        showDropshipment: this.getSupplierSetting("show_dropshipment", false),
        showOrderDescription: this.getSupplierSetting("show_order_desc", false),
        showItemPhoto: this.getSupplierSetting("show_item_photo", false),
        showSku: this.getSupplierSetting("show_sku", false),
        showUpc: this.getSupplierSetting("show_upc", false),
        hideSkuCol: this.getSupplierSetting("hide_sku_col", false),
        onGetOrderDTO: null,
        showBillTo: this.getSupplierSetting("show_bill_to", true),
        showShipToPhone: this.getSupplierSetting("show_ship_to_phone", true),
        showBillToPhone: this.getSupplierSetting("show_bill_to_phone", false),
        showOrderUser: this.getSupplierSetting("show_order_user", false),
        showItemLocation: this.getSupplierSetting("show_row_bin", false),
        showUom: this.getSupplierSetting("show_uom", false),
        hideBusinessName: this.getSupplierSetting("hide_business_name", false),
        inlineLogoName: this.getSupplierSetting("inline_logo_name", false),
        modalIsOpen: false,
        modalComponent: null,
        selectedTemplate: "STANDARD",
    };

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.OrderOnGetOrder, this.onGetOrder);
        this.props.socket.on(EndpointsEnum.OrderOnGetOrdersPackingList, this.onGetOrderForPackingList);
        this.props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierSettings, this.onUpdateSupplierSettings);
        this.props.socket.on(EndpointsEnum.PackingListOnGenerateAveryLabels, this.onDownloadAveryLabels);

        const params = new URLSearchParams(this.props.location.search);

        const navItemsArr: IBreadcrumbs[] = [{ title: "Dashboard", url: "/dashboard" }];

        if (this.props.location.pathname.indexOf("shipments") >= 0) {
            navItemsArr.push({ title: "Shipments", url: "/shipments" });
        } else {
            navItemsArr.push({ title: "Orders", url: "/orders" });
        }

        navItemsArr.push({ title: "Packing List", url: "" });

        const orders = params.get("orders");

        if (orders) {
            const state: any = {
                orderGuids: orders.split(","),
                navItems: navItemsArr,
            };

            this.setState(state, () => {
                this.getOrderForPackingList();
            });
        }
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.OrderOnGetOrder, this.onGetOrder);
        this.props.socket.removeListener(EndpointsEnum.OrderOnGetOrdersPackingList, this.onGetOrderForPackingList);
        this.props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierSettings, this.onUpdateSupplierSettings);
        this.props.socket.removeListener(EndpointsEnum.PackingListOnGenerateAveryLabels, this.onDownloadAveryLabels);
    }

    getOrder = () => {
        if (this.props.userModel && this.props.supplierModel) {
            const orderGuids = this.state.orderGuids;

            console.log("orderGuids", orderGuids);

            const payload: any = {
                orderGuids,
                supplierGuid: this.props.supplierModel.guid,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
            };

            this.props.socket.emit("getOrder", payload);
        }
    };

    getOrderForPackingList = () => {
        if (this.props.userModel && this.props.supplierModel) {
            const orderGuids = _.map(this.state.orderGuids, (guid) => {
                return { guid };
            });

            console.log("orderGuids", orderGuids);

            const payload: any = {
                orders: orderGuids,
                supplierGuid: this.props.supplierModel.guid,
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
            };

            this.props.socket.emit("getOrdersPackingList", payload);
        }
    };

    onGetOrder = (data: any) => {
        console.log("onGetOrder", data);
        const navItems = this.state.navItems;

        // TODO - Setup For The Order Name in the Breadcrumb
        // navItems![2].title = `${data.order.name} Packing List`;
        this.setState({
            onGetOrderDTO: data.order,
            // navItems,
        });
    };

    onGetOrderForPackingList = (data: any) => {
        console.log("onGetOrderForPackingList", data);
        this.setState({
            orders: data.orders,
        });
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    saveViewOptions = () => {
        const payload: IUpdateSupplierSettingsDTO = {
            supplierGuid: this.props.supplierModel.guid,
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            // @ts-expect-error
            settings: {
                simple_packing_list: {
                    show_phone: this.state.showPhone,
                    show_email: this.state.showEmail,
                    show_order_qty: this.state.showOrderQty,
                    show_ship_qty: this.state.showShipQty,
                    show_dropshipment: this.state.showDropshipment,
                    show_order_desc: this.state.showOrderDescription,
                    show_sku: this.state.showSku,
                    show_upc: this.state.showUpc,
                    hide_sku_col: this.state.hideSkuCol,
                    show_ship_to_phone: this.state.showShipToPhone,
                    show_bill_to_phone: this.state.showBillToPhone,
                    show_order_user: this.state.showOrderUser,
                    show_row_bin: this.state.showItemLocation,
                    show_uom: this.state.showUom,
                    inline_logo_name: this.state.inlineLogoName,
                    show_bill_to: this.state.showBillTo,
                    show_item_photo: this.state.showItemPhoto,
                    hide_business_name: this.state.hideBusinessName,
                },
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, payload);
    };

    onUpdateSupplierSettings = (data: IOnUpdateSupplierSettingsDTO) => {
        const message: INotification = {
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
            message: "successfully_updated_settings",
        };

        this.props.notifyFn(null, message);
    };

    closeModalFn = () => {
        this.setState({
            modalIsOpen: false,
            modalComponent: null,
        });
    };

    submitOrders = () => {
        const modalComponent = (
            <BulkOrderSubmitModal
                orderGuids={this.state.orderGuids}
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                closeModalFn={this.closeModalFn}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                selectAll={true}
            />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    downloadAveryLabels = () => {
        if (this.state.orderGuids) {
            const orderGuids = this.state.orderGuids.reverse();

            const payload: IVermontAvery8136DTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                orderGuids,
            };

            this.props.socket.emit(EndpointsEnum.PackingListGenerateAveryLabels, payload);
        }
    };

    onDownloadAveryLabels = (data: IOnVermontAvery8136DTO) => {
        UIService.downloadDataFile(data.pdfData, "AveryLabels.pdf", "application/pdf");
    };

    selectTemplate = (template: IOption) => {
        this.setState({
            selectedTemplate: template.value as "STANDARD" | "MINIMAL",
        });
    };

    render() {
        if (!this.props.supplierModel || !this.props.userModel) {
            return null;
        }

        const viewOptions: IViewOptions[] = [
            {
                title: "hide_business_name",
                prop: "hideBusinessName",
                type: ControlTypeEnum.checkbox,
                value: this.state.hideBusinessName,
            },
            {
                title: "inline_logo_name",
                prop: "inlineLogoName",
                type: ControlTypeEnum.checkbox,
                value: this.state.inlineLogoName,
            },
            {
                title: "show_item_photo",
                prop: "showItemPhoto",
                type: ControlTypeEnum.checkbox,
                value: this.state.showItemPhoto,
            },
            {
                title: "hide_sku_col",
                prop: "hideSkuCol",
                type: ControlTypeEnum.checkbox,
                value: this.state.hideSkuCol,
            },
            {
                title: "show_sku",
                prop: "showSku",
                type: ControlTypeEnum.checkbox,
                value: this.state.showSku,
            },
            {
                title: "show_order_description",
                prop: "showOrderDescription",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderDescription,
            },
            {
                title: "show_upc",
                prop: "showUpc",
                type: ControlTypeEnum.checkbox,
                value: this.state.showUpc,
            },
            {
                title: "show_phone",
                prop: "showPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showPhone,
            },
            {
                title: "show_email",
                prop: "showEmail",
                type: ControlTypeEnum.checkbox,
                value: this.state.showEmail,
            },
            {
                title: "show_order_qty",
                prop: "showOrderQty",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderQty,
            },
            {
                title: "show_ship_qty",
                prop: "showShipQty",
                type: ControlTypeEnum.checkbox,
                value: this.state.showShipQty,
            },
            {
                title: "show_dropshipment",
                prop: "showDropshipment",
                type: ControlTypeEnum.checkbox,
                value: this.state.showDropshipment,
            },
            {
                title: "show_bill_to",
                prop: "showBillTo",
                type: ControlTypeEnum.checkbox,
                value: this.state.showBillTo,
            },
            {
                title: "show_bill_to_phone",
                prop: "showBillToPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showBillToPhone,
            },
            {
                title: "show_ship_to_phone",
                prop: "showShipToPhone",
                type: ControlTypeEnum.checkbox,
                value: this.state.showShipToPhone,
            },
            {
                title: "show_order_user",
                prop: "showOrderUser",
                type: ControlTypeEnum.checkbox,
                value: this.state.showOrderUser,
            },
            {
                title: "show_item_location",
                prop: "showItemLocation",
                type: ControlTypeEnum.checkbox,
                value: this.state.showItemLocation,
            },
            {
                title: "show_uom",
                prop: "showUom",
                type: ControlTypeEnum.checkbox,
                value: this.state.showUom,
            },
        ];

        const packingListTemplates: IOption[] = [
            { value: "STANDARD", label: "8.5x11" },
            { value: "MINIMAL", label: "4x6" },
        ];

        return (
            <OrderPackingListWrapper className="OrderPackingList ShipmentPackingList col-12 mt-2">
                <OwViewOptionsPanel
                    saveFn={this.saveViewOptions}
                    showSaveBtn={true}
                    viewOptions={viewOptions}
                    onChangeFn={this.handleChange}
                />

                <div className={"row mb-2 d-flex justify-content-between align-items-center flex-wrap d-print-none"}>
                    <div className={"d-inline-flex"}>
                        <Breadcrumbs hasTopMargin={false} navItems={this.state.navItems} />
                    </div>
                    <div className={"d-print-none text-end"}>
                        <OwPrintButton />
                        <div className={"ms-auto w-10r"}>
                            <OwSelectOption
                                valueProp={"value"}
                                titleProp={"label"}
                                fn={this.selectTemplate}
                                name={"template"}
                                options={packingListTemplates}
                                emitObject={true}
                                selectedOption={this.state}
                                selectedOptionProp={"selectedTemplate"}
                            />
                        </div>

                        {this.props.supplierModel.show_submit_on_packing_list ? (
                            <OwButton title={"submit_orders"} fn={this.submitOrders} />
                        ) : null}
                        {this.props.supplierModel.guid === SupplierGuidEnum.VERMONT ? (
                            <OwButton title={"labels_pdf_download"} fn={this.downloadAveryLabels} />
                        ) : null}
                    </div>
                </div>

                {this.state.orders.length
                    ? _.map(this.state.orders, (order) => {
                          return (
                              <PackingListSurround key={order.guid} className={"PackingListContainer"}>
                                  <OrderPackingListView
                                      key={order.guid}
                                      order={order}
                                      hideBusinessName={this.state.hideBusinessName}
                                      showItemPhoto={this.state.showItemPhoto}
                                      hideSkuCol={this.state.hideSkuCol}
                                      showOrderQty={this.state.showOrderQty}
                                      showShipQty={this.state.showShipQty}
                                      showDropshipment={this.state.showDropshipment}
                                      showOrderDescription={this.state.showOrderDescription}
                                      showPhone={this.state.showPhone}
                                      showEmail={this.state.showEmail}
                                      showSku={this.state.showSku}
                                      showUpc={this.state.showUpc}
                                      showBillTo={this.state.showBillTo}
                                      showBillToPhone={this.state.showBillToPhone}
                                      showShipToPhone={this.state.showShipToPhone}
                                      showOrderUser={this.state.showOrderUser}
                                      showItemLocation={this.state.showItemLocation}
                                      showUom={this.state.showUom}
                                      inlineLogoName={this.state.inlineLogoName}
                                      sortCol={"item_no"}
                                      template={this.state.selectedTemplate}
                                  />
                              </PackingListSurround>
                          );
                      })
                    : null}

                <Modal
                    isOpen={this.state.modalIsOpen}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}
                    style={{}}>
                    {this.state.modalComponent}
                </Modal>
            </OrderPackingListWrapper>
        );
    }
}

export default OrderPackingList;

const PackingListSurround = styled.div`
    page-break-after: always;

    &:last-of-type {
        page-break-after: unset;
    }
`;

const OrderPackingListWrapper = styled.div`
    @media screen {
        padding-bottom: 3rem;
    }
`;
